'use strict';

class SocialLinks {
    ui;
    internal;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                toggleBtn: this.wrap.querySelector('.js-social-links-btn'),
                printBtn: this.wrap.querySelector('.js-sharebar-print'),
                modal: this.wrap.querySelector('.js-social-links-modal'),
                docbody: document.querySelector('body')
            };

            this.internal = {
                isOpen: false
            };

            this.bindUIActions();
        }
    }

    bindUIActions() {
        if (this.ui.printBtn) {
            this.ui.printBtn.addEventListener('click', () => this.printBtnClick());
        }

        if(this.ui.toggleBtn && this.ui.modal) {
            this.ui.toggleBtn.addEventListener('click', () => this.toggleBtnClick());
            this.ui.toggleBtn.addEventListener('keypress', () => this.toggleBtnClick());
            this.ui.docbody.addEventListener('click', (e) => this.closeModal(e));
        }

    }

    printBtnClick() {
        this.printPage();
    }

    toggleBtnClick() {
        this.toggleModal();
    }

    printPage() {
        window.print();
    }

    toggleModal() {
        if (this.wrap.classList.contains('is-closed')) {
            this.wrap.classList.remove('is-closed');
            this.wrap.classList.add('is-open');
            setTimeout(() => { this.internal.isOpen = true; }, 50);
        } else if (this.wrap.classList.contains('is-open')) {
            this.wrap.classList.remove('is-open');
            this.wrap.classList.add('is-closed');
            this.internal.isOpen = false;
        }
    }

    closeModal(e) {
        let el = e.target,
            closeModal = true;

        if (this.internal.isOpen && el !== document.querySelector('.js-social-links-btn')) {
            while (el) {
                var targetClass = el.className,
                isModal;

                if (targetClass && typeof targetClass.match === 'function') {
                    isModal = targetClass.match(/js-social-links-modal/g);
                    if (isModal) {
                        closeModal = false;
                    }
                }
                el = el.parentNode;
            }

            if (closeModal) {
                this.wrap.classList.remove('is-open');
                this.wrap.classList.add('is-closed');
                this.internal.isOpen = false;
            }
        }

    }
}

export default SocialLinks;
